import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getElkProdsAction, getBrandHomeProdsAction, setPriceAction } from '../../modules/common/prodModule';
import ProdItemList from '../../components/common/prod/ProdItemList';
import Pagination from '../../components/common/Pagination';
import { useState } from 'react';
import { sortBy } from 'lodash';
import { setCurPageAction } from '../../modules/common/cateModule';
import { useHistory } from 'react-router-dom';

const CateProdContinerBlock = styled.div``;

/**
 * 카테고리 지정 상품 리스트
 * 필터와 카테고리가 변경될때 마다 서버로 부터 Data 수신
 */
const CateProdContiner = () => {

    const dispatch = useDispatch();
    //const [curPageNum, setCurPageNum] = useState(1);
    const [curCate1Id, setCurCate1Id] = useState(0);
    const [curCate2Id, setCurCate2Id] = useState(0);
    const history = useHistory();

    const { activeFilterIds, activeCateIds, brandId, searchNow, error, loading,
        prodPrice, curSelFirstCateId, curSelScndCateId, delCate3Ids, sort, prodItems, curPageNum } = useSelector(
            ({ cateItemsReducer, loadingReducer, prodItemsReducer, brandItemsReducer }) => ({
                activeFilterIds: cateItemsReducer.activeFilterIds,
                activeCateIds: cateItemsReducer.activeCateIds,
                brandId: brandItemsReducer.selectedBrandItem.id,
                // curPage: prodItemsReducer.curPage,
                searchNow: cateItemsReducer.searchNow,
                error: cateItemsReducer.error,
                loading: loadingReducer['es/LIST_PROD_BY_CATE_FILTER'],
                prodPrice: prodItemsReducer.prodPrice,
                curSelFirstCateId: cateItemsReducer.curSelFirstCateId,
                curSelScndCateId: cateItemsReducer.curSelScndCateId,
                delCate3Ids: cateItemsReducer.delCate3Ids,
                sort: cateItemsReducer.sort,
                prodItems: prodItemsReducer.prodItems,
                curPageNum: cateItemsReducer.curPageNum,
            }));

    useEffect(() => {
      if(!!searchNow){
        if (curSelFirstCateId === 0 || curSelFirstCateId === null) {
          setCurCate1Id(curSelFirstCateId);
          dispatch(getBrandHomeProdsAction(0, 0, null, curPageNum, prodPrice.min, prodPrice.max, sort))
        } else if (curSelScndCateId === 0 || curSelScndCateId === null) {
          setCurCate1Id(curSelFirstCateId);
          dispatch(getBrandHomeProdsAction(curSelFirstCateId * 10000, 0, delCate3Ids, curPageNum, prodPrice.min, prodPrice.max, sort));
        } else {
          setCurCate2Id(curSelScndCateId);
          dispatch(getBrandHomeProdsAction(curSelScndCateId * 100, brandId, delCate3Ids, curPageNum, prodPrice.min, prodPrice.max, sort));
        }
      }
        //setCurPageNum(1);
    }, [JSON.stringify(delCate3Ids), JSON.stringify(prodPrice), brandId, sort, curPageNum,curSelScndCateId,curSelFirstCateId,searchNow]);

    // page number update
    const handleChangePageNum = (value) => {
        if (value !== curPageNum) {
            //setCurPageNum(value);
            dispatch(setCurPageAction(value));
            let cateid = 0;

            let _activeCateIds = activeCateIds;
            let _curSelFirstCateId = curSelFirstCateId;
            let _curSelScndCateId = curSelScndCateId;
            let _delCate3Ids = delCate3Ids;
            let _sort = sort;
            let _prodPrice = prodPrice;

            if(curSelFirstCateId === null){
                _curSelFirstCateId = 0;
            }
            if(curSelScndCateId === null){
                _curSelScndCateId = 0;
            }

            // console.log("curCate1Id : " + curCate1Id + " , curCate2Id : " + curCate2Id)
            if (curCate2Id > 0) {
                cateid = curCate2Id * 100;
            } else if (curCate1Id > 0) {
                cateid = curCate1Id * 10000;
            }

            // history.push("/ct",{ activeCateIds: _activeCateIds, prodPrice:_prodPrice,curSelFirstCateId:_curSelFirstCateId,
            //     curSelScndCateId:_curSelScndCateId, delCate3Ids: _delCate3Ids,sort:_sort, curPageNum:value  });
            window.scrollTo(0, 0);
        }
    }

    // Network Error 공통 처리 필요
    if (error || loading) {
        return <CateProdContinerBlock />
    }

    return (
        <CateProdContinerBlock>
            <ProdItemList prodItems={prodItems} />
            <Pagination updatePageNum={handleChangePageNum} prodItems={prodItems} />
        </CateProdContinerBlock>
    );
};

export default CateProdContiner;
